import $ from 'jquery';
import { type EditorPlugin, type AhaEditor } from '@aha-app/aha-editor-v2';
import isHotkey from '@aha-app/is-hotkey';
import { showAlertMessage } from 'javascripts/messages';

const isCmdEnter = isHotkey('mod+enter');

function checkFormForPlaceholderContent(event: JQuery.TriggeredEvent) {
  const { target } = event;

  if (
    !target ||
    !target.querySelector(':scope [data-aha-editor-placeholder]')
  ) {
    return;
  }

  showAlertMessage(
    'Your attachment(s) have not finished uploading yet. Please try again after they have finished uploading.'
  );

  event.stopPropagation();
  event.preventDefault();
  return false;
}

const SubmitFormPlugin: EditorPlugin = {
  name: 'Submit form plugin',
  handlers: {
    onMount(ahaEditor: AhaEditor) {
      const { editorContainer } = ahaEditor.controller;

      const form = editorContainer?.closest('form');
      if (form) {
        $(form).on('ajax:beforeSend', checkFormForPlaceholderContent);
      }
    },

    onKeyDown(event: KeyboardEvent, ahaEditor: AhaEditor) {
      if (!isCmdEnter(event) || !ahaEditor.controller) {
        return false;
      }

      const { controller } = ahaEditor;
      const form = controller.editorContainer?.closest('form');

      if (!form) {
        return false;
      }

      const submitButton = form.querySelector<HTMLInputElement>(
        ':scope input[type=submit][name=commit]'
      );
      if (submitButton) {
        document.body.focus();
        submitButton.click();
        return true;
      }
    },
  },
};

export default SubmitFormPlugin;
